import { BoxWithShadow } from 'components/blocks/BoxWithShadow';
import { RegularAd } from 'googlead/components/RegularAd';
import { BlockContent } from '../BlockContent';

const NoResortsBlock = ({ text }: { text: string }) => (
  <>
    <BoxWithShadow>
      <BlockContent>
        <strong>{ text }</strong>
      </BlockContent>
    </BoxWithShadow>
    <RegularAd />
  </>
);

export default NoResortsBlock;
